import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Contact({about}) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    errors: {}
  });

  const navigate = useNavigate();

  const addToDatabase = async (data) => {

    try {

      let uri = process.env.REACT_APP_Realtime_Firebase;
      let response = await fetch(uri + 'ContactQuery.json', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
  
        body: JSON.stringify(data)
      })
      
      // console.log('saved');
    }
    catch(e){
      // console.log('some error occured!')
    }


  }


  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message) newErrors.message = 'Message is required';
    return newErrors;
  };

  const contactSubmission = async(e) => {
    e.preventDefault();
    const formErrors = validateForm();

    try{

    
        if (Object.keys(formErrors).length === 0) {
          // console.log(formData)

          await addToDatabase(formData);
          
          alert('Your contact form has been submitted successfully!');
          navigate('/');
        } else {
          setFormData({ ...formData, errors: formErrors });
        }
      }
      catch(e)
      {
        // console.log(e);

      }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <section className={`bg-gray-800 py-12 px-2 ${about ? '' : 'h-screen'} `}>
      <div className="container mx-auto text-center">
        <h2 className="text-3xl text-white font-bold mb-4">Contact Us</h2>
        <p className="text-gray-400 mb-8">Have any questions or feedback? Get in touch with us!</p>
        <form onSubmit={contactSubmission} className="max-w-md mx-auto">
          <div className="mb-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.name}
              onChange={handleChange}
            />
            {formData.errors.name && <p className="text-red-500 text-sm">{formData.errors.name}</p>}
          </div>
          <div className="mb-4">
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.email}
              onChange={handleChange}
            />
            {formData.errors.email && <p className="text-red-500 text-sm">{formData.errors.email}</p>}
          </div>
          <div className="mb-4">
            <textarea
              name="message"
              placeholder="Your Message"
              className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {formData.errors.message && <p className="text-red-500 text-sm">{formData.errors.message}</p>}
          </div>
          <button type="submit" className="px-4 py-2 bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:outline-none">Send Message</button>
        </form>
      </div>
    </section>
  );
}
